import Vue from "vue";
import Vuex from "vuex";
import { auth } from "./auth.module";
import { course } from "./course.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    courseActive: false
  },
  mutations: {
    setCourseActive(state, data) {
      console.log("courseActive", data);
      state.courseActive = data;
    }
  },
  modules: {
    auth,
    course
  }
});
